import React, { useMemo } from 'react';
import classNames from 'classnames';
import { STEPPER_LEAD_STAGES } from '../../utils';
import LeadStepperStep from './components/LeadStepperStep';

import './LeadsStepper.styles.scss';

type LeadsStepperProps = {
  className?: string;
  canEditColumnName?: boolean;
};

const LeadsStepper: React.FC<LeadsStepperProps> = (props) => {
  const { className, canEditColumnName = false } = props;

  const classes = classNames('leads-stepper', className);

  const renderSteps = useMemo(
    () =>
      Object.values(STEPPER_LEAD_STAGES).map((stage) => (
        <LeadStepperStep
          key={stage}
          stage={stage}
          canEditColumnName={canEditColumnName}
        />
      )),
    [canEditColumnName],
  );

  return <ul className={classes}>{renderSteps}</ul>;
};

export default LeadsStepper;
